import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BaseComponent } from "../../../base.component";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { customEmailFormValidator } from "../../../_helpers/customEmailFormValidator";
import { DataService } from "../../../_services/data.service";
import { AlertService } from "../../../_services/alert.service";
import { autoFillForms } from "../../../_helpers/auto-fill-forms/auto-fill-forms";

@Component({
  moduleId: module.id,
  selector: "cash",
  templateUrl: "cash.component.html",
  styleUrls: ["./cash.component.css"],
})
export class CashComponent extends BaseComponent {
  @Input() public numberOfPayments: number;
  @Input() public maxNumberOfPayments: number;
  @Input() public amount: number;
  @Output() public actionCompleted?: EventEmitter<void> =
    new EventEmitter<void>();
  public errorMessage: string;
  public loading: boolean = false;
  public successMessage: string;

  public formGroupObj: FormGroup;

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
    autoFillForms(this, { shouldSubmit: false });
  }

  run() {
    this.formGroupObj = new FormGroup({
      firstName: new FormControl(null, Validators.required),
      lastName: new FormControl(null, Validators.required),
      email: new FormControl(null, [
        Validators.required,
        Validators.email,
        customEmailFormValidator(),
      ]),
      phone: new FormControl(null, this.validatePhone),
      payments: new FormArray([]),
    });
    for (let i = 0; i < this.numberOfPayments; i++) this.addPayment();
  }

  getArrayControls() {
    return (<FormArray>this.formGroupObj.get("payments")).controls;
  }

  addPayment() {
    let control = <FormArray>this.formGroupObj.controls["payments"];
    let fG = new FormGroup({
      isCash: new FormControl(control.length > 0 ? false : true),
      amount: new FormControl(null, [Validators.required]),
      chequeDate: new FormControl(
        null,
        control.length > 0 ? this.validateDate : null
      ),
      chequeNumber: new FormControl(
        null,
        control.length > 0 ? [Validators.required] : null
      ),
    });
    control.push(fG);
    this.updateValidators(fG);
  }

  removePayment(index) {
    let control = <FormArray>this.formGroupObj.controls["payments"];
    control.removeAt(index);
  }

  validatePhone(c: FormControl) {
    let PHONE_REGEXP =
      /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    return !c.value || PHONE_REGEXP.test(c.value)
      ? null
      : {
          validatePhone: {
            valid: false,
          },
        };
  }

  validateDate(c: FormControl) {
    let regEx = /^\d{4}-\d{2}-\d{2}$/;
    let dateString = c.value;
    if (!dateString || !dateString.match(regEx))
      return {
        validateDate: {
          valid: false,
        },
      }; // Invalid format
    let d = new Date(dateString);
    if (Number.isNaN(d.getTime()))
      return {
        validateDate: {
          valid: false,
        },
      }; // Invalid date
    return d.toISOString().slice(0, 10) === dateString
      ? null
      : {
          validateDate: {
            valid: false,
          },
        };
  }

  validatePayments(c: FormArray) {
    return {
      validatePayments: {
        valid: true,
      },
    };
  }

  updateValidators(formGroup: FormGroup) {
    formGroup.get("isCash").valueChanges.subscribe((isCash) => {
      formGroup
        .get("chequeDate")
        .setValidators(isCash ? null : this.validateDate);
      formGroup
        .get("chequeNumber")
        .setValidators(isCash ? null : [Validators.required]);

      formGroup.get("chequeNumber").updateValueAndValidity();
      formGroup.get("chequeDate").updateValueAndValidity();
    });
  }

  submit() {
    if (!this.loading) {
      this.errorMessage = undefined;
      let payments = this.formGroupObj.getRawValue().payments;

      let total = 0;
      payments.forEach((p) => {
        total += p["amount"];
      });

      if (total == this.amount) {
        this.loading = true;
        this.dataService
          .postEntity("checkout-cash", this.formGroupObj.getRawValue())
          .subscribe(
            (data) => {
              this.loading = false;
              this.successMessage = `תודה רבה, התשלום בוצע בהצלחה. קבלה תשלח אל ההורה במייל. `;
            },
            (error) => {
              this.loading = false;
              let body = error.json && error.json();
              this.alertService.error(
                body && body.statusText
                  ? this.base.messages[body.statusText]
                    ? this.base.messages[body.statusText]
                    : decodeURIComponent(body.statusText)
                  : (error && error.statusText) || error
              );
            }
          );
      } else {
        this.errorMessage =
          "הסכום לתשלום הינו " +
          this.amount +
          " וסכום התשלומים שכתבת הינו " +
          total +
          ",יש לתקן בהתאם";
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/components/cash/cash.component.ts